"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = require("../index");
var styles_1 = require("./styles");
function RenderSkeletonLoader(_a) {
    var pageSize = _a.pageSize;
    return (react_1.default.createElement(react_1.default.Fragment, null, Array(pageSize)
        .fill('skeleton')
        .map(function (item, index) { return (react_1.default.createElement(index_1.Grid, { key: index, item: true, xs: true, "data-testid": "media-library-".concat(item) },
        react_1.default.createElement(styles_1.StyledCard, { skeleton: true, key: index },
            react_1.default.createElement(index_1.Skeleton, { variant: "rectangular", width: '100%', height: '100%' })))); })));
}
exports.default = RenderSkeletonLoader;
//# sourceMappingURL=RenderSkeletonLoader.js.map